import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import classNames from "classnames"
import memo from "set-state-compare/build/memo"
import React from "react"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"

/**
 * @typedef {object} ComponentsUserUnicornProfileBoxProps
 * @property {unknown} className
 */

/** @typedef {object} ComponentsUserUnicornProfileBoxState */

/**
 * @extends {ShapeComponent<ComponentsUserUnicornProfileBoxProps, ComponentsUserUnicornProfileBoxState>}
 */
class ComponentsUserUnicornProfileBox extends ShapeComponent {
  render() {
    const {t} = useI18n({namespace: "js.components.user.unicorn.profile_box"})
    const {className, ...restProps} = this.props

    return (
      <div className={classNames("components--user--unicorn--profile-box", className)} {...restProps}>
        <div className="profile-box-header">
          {t(".profile")}
        </div>
        <div className="profile-box-score-factor" style={{marginBottom: "76px"}}>
          {t(".independent")}
        </div>
        <div className="profile-box-score-factor">
          {t(".active")}
        </div>
      </div>
    )
  }
}

export default memo(shapeComponent(ComponentsUserUnicornProfileBox))
